<style scoped lang="scss">
@import "../user";
@import "./ipone";
.search-form .el-input{
  width: 500px;
}
</style>
<template>
  <div class="user">
    <section>
      <h3 class="title">绑定优惠券</h3>
      <div class="search-form1">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="优惠券" prop="coupons" class="coup">
            <el-input v-model="ruleForm.coupons" clearable></el-input>
          </el-form-item>
          <el-form-item style="margin-left: 100px;float: left;" class="couppp">
            <el-button type="primary" @click="bindCoupon('ruleForm')" class="sanger_button">绑定优惠券</el-button>
            <el-button @click="$router.push('/user')" class="sanger_button">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </section>
  </div>
</template>

<script>
import {bind} from "../../../services/api.index";
export default {
  data() {
    return {
      ruleForm:{
        coupons: '',
      },
      rules:{
        coupons: [
          { required: true, message: '请输入优惠券名称', trigger: 'blur' },
          { min: 25, max: 55, message: '长度在 25 到 55 个字符', trigger: 'blur' }
        ],
      },
    }
  },

  methods: {
    bindCoupon(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const {coupons}  = this.ruleForm
          bind(coupons).then(async(res) => {
            console.log('res',res)
            if (res.data === true) {
              this.$message.success('绑定成功');
              await this.$router.push('/user/My_Coupons')
            } else {
              this.$message.warning('该优惠券兑换码已经被绑定');
              return false
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/children/Binding_Coupons.vue